import {Pipe, PipeTransform} from '@angular/core';
import Utils from '../../_helpers/utils';

@Pipe({
    name: 'truncate',
    pure: true
})
export class TruncatePipe implements PipeTransform {
    transform(content: string, truncateBy: number, truncateAt: 'begining' | 'middle' | 'end'): any {
        return Utils.truncate(content, truncateBy, truncateAt);
    }
}
